import o from "prop-types";
import a, { Component as S } from "react";
import T from "react-dom";
import { L as d } from "./utils-Ci4OZEP4.es.js";
import x from "react-focus-lock";
import g from "classnames";
import { spacing500 as O } from "mintel-tokens";
import { Transition as A } from "react-transition-group";
import { I as b } from "./IconButton-C3Bh2v_G.es.js";
import { useMediaQuery as D } from "react-responsive";
import { T as y } from "./index-BB-Wk85r.es.js";
import { u as P } from "./ThemeProvider--i7ESlT5.es.js";
import { u as U } from "./utils-C0l876fA.es.js";
import './Modal2.css';const $ = "#ccc", Y = "#fff", W = "#ccc", K = "#ccc", z = "#fff", F = "#2b2b2b", j = "768px", Q = "ModalContent-module__container___MSisK", G = "ModalContent-module__modalRightArrow___1Rk5-", J = "ModalContent-module__modalLeftArrow___A-cfc", X = "ModalContent-module__styledContainer___d0SIb", Z = "ModalContent-module__compereHeader___6Gn2W", V = "ModalContent-module__mintelHeader___MxWHJ", ee = "ModalContent-module__lightHeader___r2SxI", oe = "ModalContent-module__closeButton___u3OUg", l = {
  arrowColor: $,
  arrowHoverColor: Y,
  closeButtonColor: W,
  closeButtonHoverColor: K,
  brandedCloseButtonColor: z,
  lightHeaderCloseButtonColor: F,
  tabletBreakpoint: j,
  container: Q,
  modalRightArrow: G,
  modalLeftArrow: J,
  styledContainer: X,
  compereHeader: Z,
  mintelHeader: V,
  lightHeader: ee,
  closeButton: oe
}, h = (e) => {
  let t = null;
  return e.direction === "left" ? t = l.modalLeftArrow : e.direction === "right" && (t = l.modalRightArrow), /* @__PURE__ */ a.createElement(
    b,
    {
      className: t,
      name: "next",
      size: e.mobileOrSmaller ? 40 : "inherit",
      color: l.arrowColor,
      onClick: e.onClick,
      hoverColor: l.arrowHoverColor,
      label: e.label
    }
  );
};
h.propTypes = {
  direction: o.oneOf(["left", "right"]).isRequired,
  onClick: o.func.isRequired,
  mobileOrSmaller: o.bool.isRequired,
  label: o.string.isRequired
};
const f = (e) => `${e.replace(/\s+/g, "-").toLowerCase()}-id`, _ = (e) => {
  const { t } = U(), n = D({
    maxWidth: l.tabletBreakpoint
  }), s = P();
  let r = l.closeButtonColor;
  return e.title && (e.lightHeader ? r = l.lightHeaderCloseButtonColor : r = l.brandedCloseButtonColor), /* @__PURE__ */ a.createElement("div", { className: l.content }, e.showNavigateLeft && /* @__PURE__ */ a.createElement(
    h,
    {
      direction: "left",
      onClick: e.onNavigateLeft,
      label: e.navigateLeftLabel || t("show previous"),
      mobileOrSmaller: n
    }
  ), !e.hideCloseIcon && /* @__PURE__ */ a.createElement(
    b,
    {
      name: "close",
      onClick: e.closeModal,
      className: l.closeButton,
      size: "1.25rem",
      color: r,
      hoverColor: l.closeButtonHoverColor,
      label: t("Close modal")
    }
  ), /* @__PURE__ */ a.createElement(
    "div",
    {
      className: g(l.container, {
        [l.styledContainer]: e.title
      })
    },
    e.title && /* @__PURE__ */ a.createElement(
      "div",
      {
        className: g([
          s === "compere" ? l.compereHeader : l.mintelHeader,
          e.lightHeader && l.lightHeader
        ])
      },
      n ? /* @__PURE__ */ a.createElement(
        y.Heading5,
        {
          id: f(e.title),
          darkBg: !e.lightHeader,
          responsive: !0,
          tagName: "span"
        },
        e.title
      ) : /* @__PURE__ */ a.createElement(
        y.Heading2,
        {
          id: f(e.title),
          darkBg: !e.lightHeader,
          responsive: !0,
          tagName: "span"
        },
        e.title
      )
    ),
    e.children
  ), e.showNavigateRight && /* @__PURE__ */ a.createElement(
    h,
    {
      direction: "right",
      onClick: e.onNavigateRight,
      label: e.navigateRightLabel || t("show next"),
      mobileOrSmaller: n
    }
  ));
};
_.propTypes = {
  hideCloseIcon: o.bool.isRequired,
  closeModal: o.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  children: o.any.isRequired,
  showNavigateLeft: o.bool.isRequired,
  showNavigateRight: o.bool.isRequired,
  onNavigateLeft: o.func.isRequired,
  onNavigateRight: o.func.isRequired,
  navigateLeftLabel: o.string,
  navigateRightLabel: o.string,
  title: o.string.isRequired,
  lightHeader: o.bool.isRequired
};
_.defaultProps = {
  navigateLeftLabel: void 0,
  navigateRightLabel: void 0
};
const te = "#fff", ae = "#ccc", le = "Modal-module__body_stop_scroll___9D599", ie = "Modal-module__modal_background_blue___2fsrM", ne = "Modal-module__modal_background_black___RhRDe", re = "Modal-module__modal_dialog___qZd7r", se = "Modal-module__modal___DPUUL", de = "Modal-module__center___XTUY-", ce = "Modal-module__left___vuIQl", me = "Modal-module__right___y65tc", ue = "Modal-module__closeButton___qIIlq", i = {
  closeButtonColor: te,
  closeButtonHoverColor: ae,
  body_stop_scroll: le,
  modal_background_blue: ie,
  modal_background_black: ne,
  modal_dialog: re,
  modal: se,
  center: de,
  left: ce,
  right: me,
  closeButton: ue
}, c = ({
  show: e,
  animation: t,
  defaultStyle: n,
  animationStyles: s,
  ...r
}) => t ? /* @__PURE__ */ a.createElement(
  A,
  {
    in: e,
    timeout: {
      enter: 0,
      exit: 200
    },
    appear: !0,
    mountOnEnter: !0,
    unmountOnExit: !0
  },
  (u) => /* @__PURE__ */ a.createElement(
    "div",
    {
      role: "presentation",
      style: { ...n, ...s[u] },
      ...r
    }
  )
) : e ? /* @__PURE__ */ a.createElement("div", { role: "presentation", ...r }) : null;
c.propTypes = {
  show: o.bool.isRequired,
  animation: o.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  defaultStyle: o.object,
  // eslint-disable-next-line react/forbid-prop-types
  animationStyles: o.object
};
c.defaultProps = {
  defaultStyle: {},
  animationStyles: {}
};
const ge = {
  transition: "opacity 300ms linear",
  opacity: 0
}, he = {
  entering: { opacity: 0, display: "block" },
  entered: { opacity: 1, display: "block" },
  exiting: { opacity: 0, display: "block" },
  exited: { opacity: 0, display: "none" }
}, fe = {
  transition: "transform 300ms ease-out, opacity 300ms linear",
  transform: "translateY(-25vh)",
  opacity: 0
}, be = {
  entering: { transform: "translateY(-25vh)", opacity: 0, display: "block" },
  entered: { transform: "translateY(0)", opacity: 1, display: "block" },
  exiting: { transform: "translateY(-25vh)", opacity: 0, display: "block" },
  exited: { transform: "translateY(-25vh)", opacity: 0 }
}, _e = () => {
  document.documentElement.classList.add(i.body_stop_scroll);
}, R = () => {
  document.documentElement.classList.remove(i.body_stop_scroll);
};
class m extends S {
  state = {
    show: this.props.show
  };
  componentDidMount() {
    document.body.addEventListener("keydown", this.handleKeyDown), this.updateScroll();
  }
  UNSAFE_componentWillReceiveProps(t) {
    this.props.show !== t.show && this.setState({ show: t.show });
  }
  componentDidUpdate(t, n) {
    (t.show !== this.props.show || n.show !== this.state.show) && this.updateScroll();
  }
  componentWillUnmount() {
    R(), document.body.removeEventListener("keydown", this.handleKeyDown);
  }
  handleKeyDown = (t) => {
    t.key === "Escape" ? this.closeModal() : t.key === "ArrowLeft" && this.props.showNavigateLeft ? this.props.onNavigateLeft() : t.key === "ArrowRight" && this.props.showNavigateRight && this.props.onNavigateRight();
  };
  updateScroll() {
    this.state.show ? _e() : R();
  }
  closeModal = () => {
    this.props.closeable && (this.setState({ show: !1 }), this.props.remove_modal());
  };
  ref = a.createRef();
  render() {
    const {
      animation: t,
      ariaLabelledBy: n,
      backgroundColor: s,
      children: r,
      closeIfOutsideClick: u,
      hideBackgroundCloseIcon: L,
      hideCloseIcon: k,
      onNavigateLeft: w,
      onNavigateRight: N,
      showNavigateLeft: B,
      showNavigateRight: H,
      navigateLeftLabel: M,
      navigateRightLabel: p,
      title: C,
      marginTop: q,
      lightHeader: I
    } = this.props;
    return /* @__PURE__ */ a.createElement(
      c,
      {
        show: this.state.show,
        animation: t,
        defaultStyle: ge,
        animationStyles: he,
        className: s === "black" ? i.modal_background_black : i.modal_background_blue,
        onClick: (E) => {
          u && this.ref.current && !this.ref.current.contains(E.target) && this.closeModal();
        }
      },
      /* @__PURE__ */ a.createElement(x, { returnFocus: !0 }, !L && /* @__PURE__ */ a.createElement(
        b,
        {
          name: "close",
          onClick: this.closeModal,
          className: i.closeButton,
          size: 40,
          color: i.closeButtonColor,
          hoverColor: i.closeButtonHoverColor,
          style: { position: "fixed" }
        }
      ), /* @__PURE__ */ a.createElement(
        c,
        {
          show: this.state.show,
          animation: t,
          defaultStyle: fe,
          animationStyles: be,
          className: i.modal_dialog,
          style: { textAlign: this.props.align }
        },
        /* @__PURE__ */ a.createElement(
          "div",
          {
            className: g([
              i.modal,
              i[this.props.align]
            ]),
            role: "dialog",
            ref: this.ref,
            "aria-modal": !0,
            "aria-labelledby": n || f(C),
            style: {
              marginTop: `calc(${q}px + ${O})`
            }
          },
          /* @__PURE__ */ a.createElement(
            _,
            {
              closeModal: this.closeModal,
              hideCloseIcon: k,
              showNavigateLeft: B,
              showNavigateRight: H,
              onNavigateLeft: w,
              onNavigateRight: N,
              navigateLeftLabel: M,
              navigateRightLabel: p,
              title: C,
              lightHeader: I
            },
            r
          )
        )
      ))
    );
  }
}
m.propTypes = {
  ariaLabelledBy: d,
  backgroundColor: o.oneOf(["black", "blue"]).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  children: o.any.isRequired,
  closeable: o.bool.isRequired,
  remove_modal: o.func.isRequired,
  hideCloseIcon: o.bool.isRequired,
  hideBackgroundCloseIcon: o.bool.isRequired,
  show: o.bool.isRequired,
  animation: o.bool.isRequired,
  closeIfOutsideClick: o.bool.isRequired,
  showNavigateLeft: o.bool.isRequired,
  showNavigateRight: o.bool.isRequired,
  onNavigateLeft: o.func.isRequired,
  onNavigateRight: o.func.isRequired,
  navigateLeftLabel: o.string,
  navigateRightLabel: o.string,
  title: d,
  align: o.oneOf(["center", "left", "right"]).isRequired,
  marginTop: o.number.isRequired,
  lightHeader: o.bool.isRequired
};
m.defaultProps = {
  ariaLabelledBy: "",
  title: "",
  navigateLeftLabel: void 0,
  navigateRightLabel: void 0
};
m.displayName = "ModalContainer";
const v = (e) => T.createPortal(
  /* @__PURE__ */ a.createElement(
    m,
    {
      ariaLabelledBy: e.ariaLabelledBy,
      hideCloseIcon: !e.closeable || e.hideCloseIcon,
      hideBackgroundCloseIcon: !e.closeable || e.hideBackgroundCloseIcon,
      backgroundColor: e.backgroundColor,
      closeable: e.closeable,
      show: e.show,
      remove_modal: e.remove_modal_callback,
      animation: e.animation,
      closeIfOutsideClick: e.closeIfOutsideClick,
      showNavigateLeft: e.showNavigateLeft,
      showNavigateRight: e.showNavigateRight,
      onNavigateLeft: e.onNavigateLeft,
      onNavigateRight: e.onNavigateRight,
      navigateLeftLabel: e.navigateLeftLabel,
      navigateRightLabel: e.navigateRightLabel,
      title: e.title,
      align: e.align,
      marginTop: e.marginTop,
      lightHeader: e.lightHeader
    },
    e.children
  ),
  document.body
);
v.displayName = "Modal";
v.propTypes = {
  backgroundColor: o.oneOf(["black", "blue"]),
  // eslint-disable-next-line react/forbid-prop-types
  children: o.any.isRequired,
  remove_modal_callback: o.func,
  hideCloseIcon: o.bool,
  hideBackgroundCloseIcon: o.bool,
  show: o.bool.isRequired,
  animation: o.bool,
  closeable: o.bool,
  closeIfOutsideClick: o.bool,
  showNavigateLeft: o.bool,
  showNavigateRight: o.bool,
  navigateLeftLabel: o.string,
  navigateRightLabel: o.string,
  onNavigateLeft: o.func,
  onNavigateRight: o.func,
  title: d,
  ariaLabelledBy: d,
  align: o.oneOf(["center", "right", "left"]),
  marginTop: o.number,
  lightHeader: o.bool
};
v.defaultProps = {
  backgroundColor: "black",
  remove_modal_callback: () => {
  },
  hideCloseIcon: !1,
  hideBackgroundCloseIcon: !0,
  animation: !0,
  closeable: !0,
  closeIfOutsideClick: !0,
  showNavigateLeft: !1,
  showNavigateRight: !1,
  navigateLeftLabel: void 0,
  navigateRightLabel: void 0,
  onNavigateLeft: () => {
  },
  onNavigateRight: () => {
  },
  title: "",
  align: "center",
  marginTop: 0,
  lightHeader: !1
};
export {
  v as M
};
